<template>
    <app-layout title="Data Penyedia">
        <template #header>
            <BreadCrumb :breadcrumb="$page.props.bc" />
        </template>
        <div class="py-4">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <section class="text-gray-600 body-font">
                        <div class="container px-5 py-5 mx-auto">
                            <div class="flex flex-wrap w-full mb-5 flex-col">
                                <Accordion
                                    :multiple="true"
                                    :activeIndex="[1, 2, 3, 4, 5, 6, 7]"
                                >
                                    <AccordionTab
                                        :disabled="action == 'create'"
                                    >
                                        <template #header>
                                            <span
                                                class="flex align-items-center gap-2 w-full"
                                            >
                                                <span
                                                    class="font-bold white-space-nowrap"
                                                    >Status</span
                                                >
                                            </span>
                                        </template>
                                        <StatusDokumenPengadaanInfo></StatusDokumenPengadaanInfo>
                                    </AccordionTab>

                                    <AccordionTab>
                                        <template #header>
                                            <span
                                                class="flex align-items-center gap-2 w-full"
                                            >
                                                <span
                                                    class="font-bold white-space-nowrap"
                                                    >Data Utama</span
                                                >
                                            </span>
                                        </template>
                                        <div class="p-4 lg:w-full md:w-full">
                                            <div class="flex flex-col gap-4">
                                                <div
                                                    class="field flex justify-between items-center"
                                                >
                                                    <JetLabel
                                                        class="font-bold"
                                                        for="total_hps"
                                                        value="Total HPS"
                                                    />
                                                    <div id="total_hps">
                                                        {{ formattedTotalHPS }}
                                                    </div>
                                                </div>
                                                <div
                                                    class="field flex justify-between items-center"
                                                >
                                                    <JetLabel
                                                        class="font-bold"
                                                        for="jenis_pengadaan"
                                                        value="Jenis Pengadaan"
                                                    />
                                                    <div id="jenis_pengadaan">
                                                        {{
                                                            dataViewDokumenPengadaan.nama_jenis_dokumen
                                                        }}
                                                    </div>
                                                </div>
                                                <div
                                                    class="field flex justify-between items-center"
                                                >
                                                    <JetLabel
                                                        class="font-bold"
                                                        for="nama_paket_pengadaan"
                                                        value="NAMA PAKET PENGADAAN"
                                                    />
                                                    <div
                                                        id="nama_paket_pengadaan"
                                                    >
                                                        {{
                                                            dataViewDokumenPengadaan
                                                                .dokumen_paket_pengadaan
                                                                .nama_paket_pengadaan
                                                        }}
                                                    </div>
                                                </div>
                                                <div
                                                    class="field flex justify-between items-center"
                                                >
                                                    <JetLabel
                                                        class="font-bold"
                                                        for="list_bobot_penilaian"
                                                        value="Bobot Penilaian (%)"
                                                    />
                                                    <div class="flex flex-col">
                                                        <div
                                                            v-for="each_bobot in dataViewDokumenPengadaan.dokumen_bobot_penilaian"
                                                            :key="each_bobot.id || each_bobot.nama_jenis_bobot"
                                                            class="flex justify-between items-center"
                                                        >
                                                            <span
                                                                >{{
                                                                    each_bobot.nama_jenis_bobot
                                                                }}:
                                                                {{
                                                                    each_bobot.percentage
                                                                }}
                                                                %</span
                                                            >
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </AccordionTab>

                                    <AccordionTab
                                        v-if="
                                            dataViewDokumenPengadaan
                                                .dokumen_pengadaan_file.length >
                                            0
                                        "
                                    >
                                        <template #header>
                                            <span
                                                class="flex align-items-center gap-2 w-full"
                                            >
                                                <span
                                                    class="font-bold white-space-nowrap"
                                                    >Existing File :
                                                </span>
                                            </span>
                                        </template>
                                        <MultiFileDisplay
                                            :existing_files="
                                                dataViewDokumenPengadaan.dokumen_pengadaan_file
                                            "
                                        />
                                    </AccordionTab>
                                    <AccordionTab
                                        v-if="file_uploads.length > 0"
                                    >
                                        <template #header>
                                            <span
                                                class="flex align-items-center gap-2 w-full"
                                            >
                                                <span
                                                    class="font-bold white-space-nowrap"
                                                    >File
                                                </span>
                                            </span>
                                        </template>
                                        <FileInput
                                            :file_uploads="file_uploads"
                                        />
                                    </AccordionTab>
                                    <AccordionTab
                                        v-if="
                                            dataViewDokumenPengadaan
                                                ?.dokumen_pengadaan_jadwal
                                                ?.length > 0
                                        "
                                    >
                                        <template #header>
                                            <span
                                                class="flex align-items-center gap-2 w-full"
                                            >
                                                <span
                                                    class="font-bold white-space-nowrap"
                                                    >Existing Jadwal :
                                                </span>
                                            </span>
                                        </template>
                                        <div class="p-4 lg:w-1/1 md:w-full">
                                            <ul>
                                                <li
                                                    v-for="jadwal in dataViewDokumenPengadaan.dokumen_pengadaan_jadwal"
                                                    :key="
                                                        jadwal.id_jadwal_pengadaan
                                                    "
                                                >
                                                    <strong>{{
                                                        jadwal.nama_jadwal
                                                    }}</strong
                                                    >:
                                                    {{
                                                        jadwal.existing_jadwal
                                                            .waktu_mulai
                                                    }}
                                                    -
                                                    {{
                                                        jadwal.existing_jadwal
                                                            .waktu_selesai
                                                    }}
                                                    ({{
                                                        jadwal.existing_jadwal
                                                            .tempat
                                                    }})
                                                </li>
                                            </ul>
                                        </div>
                                    </AccordionTab>
                                    <AccordionTab v-if="jadwals.length > 0">
                                        <template #header>
                                            <span
                                                class="flex align-items-center gap-2 w-full"
                                            >
                                                <span
                                                    class="font-bold white-space-nowrap"
                                                    >Jadwal AAAA
                                                </span>
                                            </span>
                                        </template>
                                        <JadwalInput :jadwals="jadwals" />
                                    </AccordionTab>
                                    <AccordionTab
                                        v-if="
                                            dataViewDokumenPengadaan.has_isian_penyedia
                                        "
                                    >
                                        <template #header>
                                            <span
                                                class="flex align-items-center gap-2 w-full"
                                            >
                                                <span
                                                    class="font-bold white-space-nowrap"
                                                    >Penyedia</span
                                                >
                                            </span>
                                        </template>
                                        <SelectPenyedia
                                            :list_penyedia="list_penyedia"
                                            :jenis_pekerjaan_id="dataViewDokumenPengadaan.paket_pengadaan?.jenis_pengadaan || null"
                                            @update:list_penyedia="
                                                list_penyedia = $event
                                            "
                                        />
                                    </AccordionTab>
                                </Accordion>
                            </div>
                            <div class="flex justify-end mt-5">
                                <button
                                    @click="submitForm"
                                    class="px-4 py-2 bg-blue-500 text-white rounded"
                                >
                                    Submit
                                </button>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
import { defineComponent } from "vue";
import AppLayout from "@/Layouts/AppLayout.vue";
import JetSectionBorder from "@/Jetstream/SectionBorder.vue";
import BreadCrumb from "@/Components/BreadCrumb";
import Accordion from "primevue/accordion";
import AccordionTab from "primevue/accordiontab";
import JetLabel from "@/Jetstream/Label";
import Input from "@/Components/Input";
import StatusDokumenPengadaanInfo from "@/Components/StatusDokumenPengadaanInfo";
import JadwalInput from "./../partials/JadwalInput.vue";
import FileInput from "./../partials/FileInput.vue";
import FileDisplay from "../partials/FileDisplay.vue";
import MultiFileDisplay from "../partials/MultiFileDisplay.vue";
import InputNumber from "primevue/inputnumber";
import Dropdown from "primevue/dropdown";
import SelectPenyedia from "../partials/SelectPenyedia.vue";

import axios from "axios";
import { Inertia } from "@inertiajs/inertia";

export default defineComponent({
    components: {
        AppLayout,
        JetSectionBorder,
        BreadCrumb,
        Accordion,
        AccordionTab,
        JetLabel,
        Input,
        StatusDokumenPengadaanInfo,
        JadwalInput,
        FileInput,
        InputNumber,
        Dropdown,
        FileDisplay,
        MultiFileDisplay,
        SelectPenyedia,
    },
    props: {
        action: String,
        dataViewDokumenPengadaan: Object,
        files: [Object, Array],
    },
    mounted() {
        console.log(
            "DATA dataViewDokumenPengadaan: ",
            this.dataViewDokumenPengadaan
        );
        // Initialize cancel token source
        this.cancelTokenSource = axios.CancelToken.source();
        
        this.initializeFile();
        this.initializeJadwal();
        this.fetchPenyedia({ query: "" });
    },
    beforeUnmount() {
        // Cancel any pending axios requests
        if (this.cancelTokenSource) {
            this.cancelTokenSource.cancel('Component unmounted');
        }
    },
    data() {
        return {
            file_uploads: [],
            jadwals: [],
            penyediaOptions: [],
            list_penyedia: [],
            cancelTokenSource: null, // For axios request cancellation

            form: {
                total_hps: null,
                id_penyedia: null,
            },
        };
    },
    computed: {
        formattedTotalHPS() {
            return new Intl.NumberFormat("id-ID", {
                style: "currency",
                currency: "IDR",
            }).format(this.dataViewDokumenPengadaan.total_hps);
        },

    },
    methods: {
        initializeFile() {
            this.dataViewDokumenPengadaan.file.forEach((file) => {
                this.file_uploads.push({
                    id_file_dokumen_pengadaan: file.id,
                    id_jadwal_pengadaan: file.id_jadwal_pengadaan,
                    id_dokumen_pengadaan: file.id_dokumen_pengadaan,
                    id_file_dokumen_prosedur: file.id_file_dokumen_prosedur,
                    kode_file: file.kode_file,
                    kode_prosedur: file.kode_prosedur,
                    nama_file: file.nama_file,
                    file_path: file.file_path,
                    file_type: file.file_type,
                    file_dokumen_type: file.file_dokumen_type,
                    file_dokumen_type_id: file.file_dokumen_type_id,
                    multiple: file.is_multiple === 1,
                    new_file: [],
                });
            });
        },
        initializeJadwal() {
            this.dataViewDokumenPengadaan.jadwal.forEach((jadwal) => {
                this.jadwals.push({
                    ...jadwal,
                    ...(this.action == "create"
                        ? {
                              existing_jadwal: {
                                  waktu_mulai: null,
                                  waktu_selesai: null,
                                  tempat: null,
                                  keterangan: null,
                              },
                          }
                        : {}),
                });
            });
        },
        async fetchPenyedia(event) {
            console.log("Keyword : ", event.value);
            
            // Cancel previous request if exists
            if (this.cancelTokenSource) {
                this.cancelTokenSource.cancel('New request initiated');
            }
            
            // Create new cancel token
            this.cancelTokenSource = axios.CancelToken.source();
            
            try {
                const response = await axios.post(
                    "/dokumen_pengadaan/search_penyedia",
                    {
                        params: {
                            keyword: event?.value || "",
                        },
                    },
                    {
                        cancelToken: this.cancelTokenSource.token
                    }
                );
                this.penyediaOptions = response.data;
            } catch (error) {
                if (!axios.isCancel(error)) {
                    console.error("Error fetching penyedia:", error);
                }
            }
        },
        submitForm() {
            Inertia.post("/dokumen_pengadaan/action_set_data", {
                uuid: this.dataViewDokumenPengadaan.uuid,
                form: this.form,
                file_uploads: this.file_uploads,
                jadwals: this.jadwals,
                list_penyedia: this.list_penyedia,
            });
        },



        formatRupiah(value) {
            return new Intl.NumberFormat("id-ID", {
                style: "currency",
                currency: "IDR",
            }).format(value);
        },
    },
});
</script>
